import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReplaceParam } from '@lib/interfaces';

@Component({
  selector: 'asw-link-label',
  templateUrl: './link-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkLabelComponent {
  @Input() class: string = '';
  @Input() label: string = '';
  @Input() paramsTranslate: ReplaceParam | ReplaceParam[] | undefined;

  get labelFullName(): string {
    return 'm_static_message-' + this.label;
  }
}